import { isSome } from '@mbfab/shared'
import { Info, TriangleAlert } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

// 使い方のルール: docs/develop/client_ui/components/feedback.md「Callout」

export type CalloutTone = 'warning' | 'info'

const CALLOUT_TONE_CLASS: Record<CalloutTone, string> = {
  warning: 'border-warning-border bg-warning-subtle text-warning-foreground',
  info: 'border-info/20 bg-info-subtle text-foreground',
}

const CALLOUT_ICON: Record<CalloutTone, ReactNode> = {
  warning: <TriangleAlert aria-hidden className="mt-0.5 size-4 shrink-0 text-warning" />,
  info: <Info aria-hidden className="mt-0.5 size-4 shrink-0 text-info" />,
}

/**
 * 操作の前から画面に出しておく注意書き（取り消せない操作の説明・前提条件・入力が欠けている旨など）。
 * 操作の結果は ResultBanner、一瞬の通知は notify を使う。中にボタンや一覧を置いてもよい
 */
export function Callout({
  tone = 'warning',
  title,
  children,
  testId,
  className,
}: {
  tone?: CalloutTone
  title?: ReactNode
  children?: ReactNode
  testId?: string
  className?: string
}) {
  return (
    <div
      data-testid={testId}
      data-tone={tone}
      className={cn(
        'flex gap-2 rounded-xl border px-4 py-3 text-sm leading-relaxed',
        CALLOUT_TONE_CLASS[tone],
        className,
      )}
    >
      {CALLOUT_ICON[tone]}
      <div className="min-w-0 flex-1 space-y-1">
        {isSome(title) && <p className="font-bold">{title}</p>}
        {children}
      </div>
    </div>
  )
}
